import { render, staticRenderFns } from "./UserPoints.vue?vue&type=template&id=16212861"
import script from "./UserPoints.vue?vue&type=script&lang=js"
export * from "./UserPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports